import React from 'react'
import './TourTag.sass'
import Icon from '../../../ui/Icon/Icon'

function TourTag({ className, icon, title, value }) {
  return (
    <div className={`Api-TourTag ${className}`}>
      <Icon name={icon} />
      <span className="TagTitle">{title}:</span>
      <span className="TagValue">{value}</span>
    </div>
  )
}

export default TourTag
